import { computed, watch } from 'vue';
import { useAnimatedElements, useGlobal, useMap, usePois } from '@/composables';

export function useAppSingleton() {
  const state = useGlobal();
  const animations = useAnimatedElements();
  const pois = usePois();
  const map = useMap();

  animations.pause();
  const isAnimationPlaying = computed(() => {
    return (
      state.isLoadingScreenTransitionendActive.value &&
      map.isRgb.value &&
      !map.isTransformationBeingApplied.value &&
      !state.isDragging.value
    );
  });
  watch(isAnimationPlaying, (newValue) => (newValue ? animations.resume() : animations.pause()));

  watch(
    () => !pois.selectedCategory.value && !pois.selectedPoi.value,
    (newValue) => {
      map.isRgb.value = newValue;
      pois.selectedSubpoiIndex.value = 0;
    },
  );

  return { isAnimationPlaying };
}

const cached = useAppSingleton();
export const useApp = () => cached;
